module.exports = __webpack_public_path__ + "img/元素7.9a95cf21.png";